// Static content data for activities, dates, reviews, etc.

export const REGISTRATION_URL = "https://avetravel.pl/register";
export const ACCOUNT_URL = "https://avetravel.pl/login";

// PDFs are served by the backend so they can be swapped without rebuilding.
const API_BASE = process.env.REACT_APP_BACKEND_URL || "";
export const docUrl = (filename) => `${API_BASE}/documents/${filename}`;

export const CONTACT = {
  email: "kontakt@avetravel.pl",
  phone: "+48 732 988 416",
  phone_hours: "11:00 – 17:00",
  instagram: "https://www.instagram.com/scootive_camp/",
  facebook: "https://www.facebook.com/scootivecamp/",
  tiktok: "https://www.tiktok.com/@scootive_com",
  youtube: "https://www.youtube.com/c/ScootiveTV",
  shop: "https://www.scootive.pl",
  park: "https://avepark.pl",
  parkNew: "https://www.park.wetwocreative.pl"
};

export const ORGANIZER = {
  name: "AvePark Sp. z o.o.",
  nip: "522-321-58-52",
  regon: "520780366",
  krs: "0000940809",
  registry_pdf: "/documents/avepark-zaswiadczenie-rejestr-organizatorow.pdf",
  brand: "AveTravel",
  street: "ul. Krakowiaków 80/98",
  city: "02-255 Warszawa",
  country: "Polska"
};

export const ACTIVITIES = [
  { id: "ride",       title: "Nauka jazdy",        title_en: "Coached riding",  title_uk: "Навчання їзди",        span: "lg:col-span-6 md:col-span-5", emoji: "01" },
  { id: "tramp",      title: "Tramp Scoot",        title_en: "Tramp Scoot",     title_uk: "Tramp Scoot",          span: "lg:col-span-3 md:col-span-3", emoji: "02" },
  { id: "wall",       title: "Ścianka",            title_en: "Climbing wall",   title_uk: "Скеледром",            span: "lg:col-span-3 md:col-span-4", emoji: "03" },
  { id: "trampolines",title: "Park trampolin",     title_en: "Trampoline park", title_uk: "Парк батутів",         span: "lg:col-span-4 md:col-span-4", emoji: "04" },
  { id: "water",      title: "Bitwa wodna",        title_en: "Water battle",    title_uk: "Водна битва",          span: "lg:col-span-4 md:col-span-4", emoji: "05", summerOnly: true },
  { id: "spa",        title: "SPA",                title_en: "SPA",             title_uk: "SPA",                  span: "lg:col-span-4 md:col-span-4", emoji: "06" },
  { id: "contest",    title: "Zawody & konkursy",  title_en: "Contests",        title_uk: "Змагання та конкурси", span: "lg:col-span-5 md:col-span-6", emoji: "07" },
  { id: "service",    title: "Bezpłatny serwis",   title_en: "Free scooter service", title_uk: "Безкоштовний сервіс", span: "lg:col-span-3 md:col-span-3", emoji: "08" },
  { id: "cinema",     title: "Kino",               title_en: "Cinema",  title_uk: "кіно",         span: "lg:col-span-4 md:col-span-3", emoji: "09" },
  { id: "grill",      title: "Grill & integracja", title_en: "Grill & hangout", title_uk: "Гриль і спілкування",  span: "lg:col-span-6 md:col-span-6", emoji: "10" },
  { id: "ping",       title: "Ping-pong & piłkarzyki", title_en: "Ping-pong & foosball", title_uk: "Пінг-понг і настільний футбол", span: "lg:col-span-3 md:col-span-3", emoji: "11" },
  { id: "art",        title: "Zajęcia artystyczne", title_en: "Art workshops", title_uk: "Творчі заняття",        span: "lg:col-span-3 md:col-span-3", emoji: "12" }
];

export const SUMMER_TERMS = [
  { id: "s1", dates: "28.06 – 04.07.2026", price: "2 990 zł", status: "available" },
  { id: "s2", dates: "05.07 – 11.07.2026", price: "2 990 zł", status: "few_left", popular: true },
  { id: "s3", dates: "12.07 – 18.07.2026", price: "2 990 zł", status: "available" },
  { id: "s4", dates: "09.08 – 15.08.2026", price: "2 990 zł", status: "available" },
  { id: "s5", dates: "16.08 – 22.08.2026", price: "2 990 zł", status: "available" }
];

export const WINTER_TERMS = [
  { id: "w1", dates: "15.02 – 21.02.2027", price: "2 790 zł", status: "available" },
  { id: "w2", dates: "22.02 – 28.02.2027", price: "2 790 zł", status: "few_left", popular: true },
  { id: "w3", dates: "01.03 – 07.03.2027", price: "2 790 zł", status: "available" }
];

// Next camp date for countdown (closest upcoming) – first summer 2026 term
export const NEXT_CAMP_DATE_ISO = "2026-06-28T10:00:00+02:00";

export const STAFF = [
  { name: "Marcin",  role: "Head instructor",  body: "Pasjonat hulajnogi, lat doświadczenia w nauczaniu trików.", initials: "MK" },
  { name: "Jacek",   role: "Instruktor",       body: "Specjalista od transferów i dużych przeszkód.",            initials: "JN" },
  { name: "Maks",    role: "Instruktor",       body: "Sesje z najmłodszymi i progresja od podstaw.",              initials: "MX" },
  { name: "Patrycja",role: "Wychowawczyni",     body: "Dba, żeby każde dziecko czuło się jak w domu.",            initials: "PT" },
  { name: "Gabrysia",role: "Wychowawczyni",     body: "Uśmiechnięta, z dystansem – ulubienica obozu.",            initials: "GB" },
  { name: "Dr Kasia",role: "Ratownik medyczny", body: "Na miejscu 24/7. Bezpieczeństwo to podstawa.",             initials: "DR" }
];

export const GALLERY_IMAGES = [
  { src: "/img/gallery/gallery1.webp", alt: "Grill & Chill", season: "summer" },
  { src: "/img/gallery/gallery2.webp", alt: "Outdoor section", season: "summer" },
  { src: "/img/gallery/gallery3.webp", alt: "Breakfast", season: "facility" },
  { src: "/img/gallery/gallery5.webp", alt: "Contest", season: "winter" },
  { src: "/img/gallery/gallery6.webp", alt: "Party", season: "summer" },
  { src: "/img/gallery/gallery7.webp", alt: "Kadra", season: "summer" },
  { src: "/img/skatepark.webp", alt: "AvePark Skatepark", season: "facility" },
  { src: "/img/gallery/gallery8.webp", alt: "Grill & Chill", season: "winter" },
  { src: "/img/gallery/gallery10.webp", alt: "Grill", season: "summer" },
  { src: "/img/gallery/gallery11.webp", alt: "Fingerpark", season: "winter" },
  { src: "/img/gallery/gallery12.webp", alt: "Water Splash", season: "summer" },
    { src: "/img/nocleg.webp", alt: "Hostel", season: "facility" }
];

export const TEXTURES = {
  light: "https://static.prod-images.emergentagent.com/jobs/f76f31a5-17a1-459a-a3bd-6e371c80aadf/images/36dd98f1779edba964735a55ecfb5006de2a4b79d64de7aacd91a7651226a8b6.png",
  dark:  "https://static.prod-images.emergentagent.com/jobs/f76f31a5-17a1-459a-a3bd-6e371c80aadf/images/11dc23a7b143ed6c857877a7369ab5965765bda72da629d7cfef43f20d84360b.png",
  action:"https://static.prod-images.emergentagent.com/jobs/f76f31a5-17a1-459a-a3bd-6e371c80aadf/images/0a9085395f1923bc9cfd23eae7866862c10ec5c4973617ddf500e60e28e81e1e.png"
};
